export const locationsStoreKey = 'locations';
